<template>
  <div class="pS_slider" ref="slider">
    <div class="slider_item banner-slider" v-for="banner in sbanners()" :key="banner.image" >
      <a :href="banner.url" v-if="banner.url"><img :src="banner.image" class="w100" alt=""></a>
      <img v-else :src="banner.image" class="w100" alt="">
      <div class="text-center mt-2" v-if="banner.label"><i>{{ banner.label }}</i></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerSlider',
  props: ['banners', 'rand'],
  methods: {
    sbanners() {
      if(this.rand){
        return this.banners.map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value)
      }else{
        return this.banners
      }
    }
  },
  mounted() {
    window.$(this.$refs.slider).slick({
      autoplay: true,
      autoplaySpeed: 10000,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      dots: false,
      infinite: true,
      arrows: true,
      swipe: true,
      rows: 0,
      prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"> < </button>',
      nextArrow: '<button type="button" class="slick-custom-arrow slick-next"> > </button>'
    });
  }
}
</script>

<style lang="scss">
.banner-slider.slick-slide {
  position: relative;
}

.slick {
  &-list {
    overflow: visible;
  }
  &-track {
    display: flex !important;
  }
  &-slide {
    display: flex;
    flex-direction: column;
    height: auto;
    &:not(.slick-active) {
      pointer-events: none;
    }
  }
  &-active {
    & + .slick-slide:not(.slick-active) {
      margin-left: -1px;
    }
  }
  &-arrow {
    position: absolute;
    width: 57px;
    height: 57px;
    background: #292929;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    color: transparent;
    user-select: none;
    left: 0;
    z-index: 2;
    cursor: pointer;
    &:before {
      content: "";
      display: block;
      background-image: url("/cloudmill/images/strSmall.svg");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 12px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -2px;
      transform: translate(-50%, -50%) rotate(-180deg);
      filter: contrast(0) brightness(2);
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      &:before {
        filter: none;
      }
    }
  }
  &-next {
    left: auto;
    right: 0;
    &:before {
      margin-left: 0;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
